"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const characteristics_1 = __importDefault(require("../checkType/characteristics"));
const characteristics_2 = require("../@types/characteristics");
const calcNucmerParseOpt = (headLines) => {
    const filters = [
        { startsWith: 'NUCMER', endsWith: 'NUCMER' },
        { startsWith: '/' },
        { startsWith: '[', endsWith: ']' },
        { startsWith: '=', endsWith: '=' }
    ];
    const split = /\s+\|\s+|\s+/;
    const splitT = /\s+/;
    const parseOpt = {
        split: split,
        filters,
        columns: [],
    };
    const columnsMap = {
        '[S1]': 'start1',
        '[E1]': 'end1',
        '[S2]': 'start2',
        '[E2]': 'end2',
        '[LEN 1]': 'alignLen',
        '[LEN 2]': 'alignLen',
        '[LEN R]': 'len1',
        '[LEN Q]': 'len2',
        '[COV R]': 'otherNumber',
        '[COV Q]': 'otherNumber',
        '[% IDY]': 'identity',
        '[TAG1]': 'ctg1',
        '[TAG2]': 'ctg2',
    };
    headLines.findIndex(line => {
        line = line.trim();
        if (line.startsWith('[') && line.endsWith(']')) {
            if (!line.includes('|'))
                parseOpt.split = splitT;
            const tagArr = line.match(/\[.+?\]/g);
            const tagsIndex = tagArr.indexOf('[TAGS]');
            tagsIndex >= 0 && tagArr.splice(tagsIndex, 1, '[TAG1]', '[TAG2]');
            tagArr.forEach(tag => {
                parseOpt.columns.push(columnsMap[tag]);
            });
            return true;
        }
        return false;
    });
    return parseOpt;
};
const getParseOptions = (alignType, headLines) => {
    switch (alignType) {
        case characteristics_2.AlignType.UNKNOWN:
            return null;
        case characteristics_2.AlignType.STANDARD:
        case characteristics_2.AlignType.BLAST:
        case characteristics_2.AlignType.MINIMAP:
        case characteristics_2.AlignType.NUCMER_B:
            return {
                split: characteristics_1.default[alignType].all.split,
                columns: characteristics_1.default[alignType].all.columns,
            };
        case characteristics_2.AlignType.NUCMER:
        case characteristics_2.AlignType.NUCMER_T:
            return calcNucmerParseOpt(headLines);
        default:
            return null;
    }
};
exports.default = getParseOptions;
